import { useTranslation } from "react-i18next";
import { FormikProps } from "formik";
import CommonModal from "PhishingManager/components/Modal";
import ModalHeader from "Pages/Reports/Saved/ReportModals/ModalHeader";
import ChangePassword from 'Pages/User/EditUser/tabs/ChangePassword';
import { useRef, useState, useEffect } from "react";
import { ChangePasswordRequest } from "Services/Api/Auth/Types";

const ChangePasswordModal = ({ onClose }: { onClose: () => void }) => {
    const [disable, setDisable] = useState(false);
    const { t } = useTranslation();
    const formikRef = useRef<FormikProps<ChangePasswordRequest>>(null);

    useEffect(() => {
        const interval = setInterval(() => {
            const formik = formikRef.current;

            if (!formik) return;

            setDisable(
                !formik.isValid ||
                !formik.dirty ||
                formik.isSubmitting
            );
        }, 400);

        return () => clearInterval(interval);
    }, []);

    return <CommonModal
        visible
        modalTitle={<ModalHeader title={t(`profile.changePassword.title`)} desc={t(`profile.changePassword.modalDescription`)} />}
        confirmText={t('user.editUser.tabs.changePasswordTab.btnText')}
        cancelText={t('phishingManager.campaignErrorModal.cancelText')}
        confirmBtnDisabled={disable}
        iconType={null}
        showConfirmBtn={true}
        onClose={onClose}
        onConfirm={() => formikRef.current?.submitForm()}
        parentClass='change-password-modal'>
        <ChangePassword formikRef={formikRef} />
    </CommonModal>
}

export default ChangePasswordModal